import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Container, Alert, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../../services/auth';
import { styles } from './styles';
import { darkModeTextField } from '../../styles/textFieldStyles';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err: any) {
      console.error('Erro ao solicitar redefinição de senha:', err);
      const errorMessage = err.response?.data?.message || 
                          err.response?.data?.error || 
                          'Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} sx={styles.paper}>
        <Box sx={styles.header}>
          <Typography component="h1" variant="h5">
            Esqueci minha senha
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={styles.subtitle}>
            Informe seu e-mail para receber um código de redefinição de senha
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={styles.alert}>
            {error}
          </Alert>
        )}

        {success ? (
          <Box sx={styles.successMessage}>
            <Alert severity="success" sx={styles.alert}>
              Se o e-mail estiver cadastrado em nosso sistema, você receberá um código de redefinição de senha.
            </Alert>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => navigate('/reset-password')}
              sx={styles.button}
            >
              Continuar para redefinição de senha
            </Button>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleSubmit} sx={styles.form}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="E-mail"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              sx={darkModeTextField}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={loading}
              sx={styles.button}
            >
              {loading ? <CircularProgress size={24} /> : 'Enviar código'}
            </Button>
          </Box>
        )}

        <Button
          startIcon={<ArrowBack />}
          component={Link}
          to="/login"
          sx={styles.backButton}
        >
          Voltar para o login
        </Button>
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
